import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import withRouter from 'components/Common/withRouter';
import PropTypes from "prop-types";

//actions
import {
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction,
  changeLayoutMode
} from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect";

//components
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import SuperAdminThemeBridge from "components/SuperAdmin/SuperAdminThemeBridge";
import SuperAdminHorizontalHeader from "components/SuperAdmin/SuperAdminHorizontalHeader";
import SuperAdminHorizontalNavbar from "components/SuperAdmin/SuperAdminHorizontalNavbar";
import TenantThemeBridge from "components/Tenant/TenantThemeBridge";

const Layout = (props) => {

  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const isRtl = i18n.language === "sa";
  const accountType = useSelector(state => state.Login?.accountType);
  const accountScope = useSelector(state => state.Login?.accountScope);
  const isSuperAdminSession =
    accountScope === "super_admin" || accountType === "superadmin";

  const selectLayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      topbarTheme: layout.topbarTheme,
      layoutWidth: layout.layoutWidth,
      isPreloader: layout.isPreloader,
      showRightSidebar: layout.showRightSidebar,
      layoutModeType: layout.layoutModeType,
    })
  );
  const {
    topbarTheme,
    layoutModeType,
    layoutWidth,
    isPreloader,
    showRightSidebar
  } = useSelector(selectLayoutProperties);

  /*
  document title
  */

  const pathName = useLocation();

  useEffect(() => {
    const title = pathName.pathname;
    let currentage = title.charAt(1).toUpperCase() + title.slice(2);

    document.title =
      currentage + " | Skote - React Admin & Dashboard Template";
  }, [pathName.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout settings
  */
  useEffect(() => {
    document.body.classList.remove("vertical-collpsed", "sidebar-enable")
    document.getElementById("main-content-rtl").classList.add("rtl-content-hor")
    document.getElementById("page-topbar").classList.add("rtl-page-topbar-hor")
    document.getElementById("main-content-rtl").classList.remove("rtl-content")
    document.getElementById("page-topbar").classList.remove("rtl-page-topbar")
  }, [])

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);

    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  }, [isPreloader]);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [dispatch, layoutModeType]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [dispatch, topbarTheme]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [dispatch, layoutWidth]);

  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>

      <div
        id="layout-wrapper"
        className={isSuperAdminSession ? "layout-platform" : undefined}
      >
        {isSuperAdminSession ? <SuperAdminThemeBridge /> : null}
        {!isSuperAdminSession ? <TenantThemeBridge /> : null}
        {isSuperAdminSession ? (
          <>
            <SuperAdminHorizontalHeader
              theme={topbarTheme}
              isMenuOpened={isMenuOpened}
              openLeftMenuCallBack={openMenu}
            />
            <SuperAdminHorizontalNavbar menuOpen={isMenuOpened} />
          </>
        ) : (
          <>
            <Header
              theme={topbarTheme}
              isMenuOpened={isMenuOpened}
              openLeftMenuCallBack={openMenu}
            />
            <Navbar menuOpen={isMenuOpened} />
          </>
        )}
        <div className="main-content" id="main-content-rtl">
          {isRtl ? (
            <SimpleBar
              className="main-content-scroll h-100"
              autoHide={false}
              forceVisible="y"
            >
              {props.children}
            </SimpleBar>
          ) : (
            props.children
          )}
        </div>
        <Footer />
      </div>

      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayout: PropTypes.func,/*  */
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any
};

export default withRouter(Layout);